import React, {FC} from 'react';
import {Link} from 'react-router-dom';

import {MenuArrowIcon} from 'features/menu/helpers/icons/menuArrow/menuArrow';

import s from './link.scss';

type PropsType = {
    to: string;
    content: string;
    onClick?: () => void;
};

/**
 *  Functional-component for Link
 *  @param {PropsType} props - Received props
 *  @returns {Node} - Rendered Link stateless component
 */
export const LinkMenu: FC<PropsType> = ({to, content, onClick}) => (
    <Link to={to} className={s.link} onClick={onClick} role="menuitem">
        {content}
        <MenuArrowIcon className={s.arrow} />
    </Link>
);
